import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowActivationChecklistResponse,
  WorkflowTestRunRequest,
  WorkflowTestRunResponse,
  WorkflowSimulateRequest,
  WorkflowSimulateResponse,
  WorkflowAudienceEstimateRequest,
  WorkflowAudienceEstimateResponse,
  WorkflowEmailTestRequest,
  WorkflowEmailTestResponse,
  WorkflowExecutionRunResponse
} from '../models/workflow-testing.model';

@Injectable({ providedIn: 'root' })
export class WorkflowTestingApiService {
  private readonly base = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) {}

  getActivationChecklist(workflowId: number): Observable<WorkflowActivationChecklistResponse> {
    return this.http.post<WorkflowActivationChecklistResponse>(
      `${this.base}/workflows/${workflowId}/activation-checklist`, {}
    );
  }

  runWorkflowTest(workflowId: number, payload: WorkflowTestRunRequest): Observable<WorkflowTestRunResponse> {
    return this.http.post<WorkflowTestRunResponse>(
      `${this.base}/workflows/${workflowId}/test-run`, payload
    );
  }

  simulateWorkflow(workflowId: number, payload: WorkflowSimulateRequest): Observable<WorkflowSimulateResponse> {
    return this.http.post<WorkflowSimulateResponse>(
      `${this.base}/workflows/${workflowId}/simulate`, payload
    );
  }

  estimateAudience(workflowId: number, payload: WorkflowAudienceEstimateRequest = {}): Observable<WorkflowAudienceEstimateResponse> {
    return this.http.post<WorkflowAudienceEstimateResponse>(
      `${this.base}/workflows/${workflowId}/estimate-audience`, payload
    );
  }

  sendWorkflowTestEmail(payload: WorkflowEmailTestRequest): Observable<WorkflowEmailTestResponse> {
    return this.http.post<WorkflowEmailTestResponse>(
      `${this.base}/workflow-actions/email/send-test`, payload
    );
  }

  getWorkflowExecutionRuns(
    params: { workflowId: number; runType?: 'TEST' | 'PRODUCTION' }
  ): Observable<WorkflowExecutionRunResponse[]> {
    let p = new HttpParams().set('workflowId', params.workflowId.toString());
    if (params.runType) p = p.set('runType', params.runType);
    return this.http.get<WorkflowExecutionRunResponse[]>(
      `${this.base}/workflow-executions/runs`, { params: p }
    );
  }
}
